import React from "react";

export default function ConfirmDialogSendNote() {
    return (
        <div>
            Une fois la note envoyée, vous ne pourrez plus la modifier ou
            l’annuler
        </div>
    );
}
